import {Component, ViewChild} from '@angular/core';
import {VerificationStatusDataSource} from './status.service';
import {MatTable} from '@angular/material/table';
import {IdentificationRequestStatus} from '../model/identification_request_status';

@Component({
	selector: 'mmmi-status',
	templateUrl: './status.component.html',
	styleUrls: ['./status.component.scss']
})
export class VerificationStatusComponent {
	@ViewChild(MatTable) status!: MatTable<IdentificationRequestStatus>;

	constructor(readonly model: VerificationStatusDataSource) {}

	refresh() {
		if (this.status != null) {
			console.info('refreshing status table');
			this.status.renderRows();
		} else {
			console.error('could not access status table child component');
		}
	}
}
